import {
  type TransactionGroup,
  Transaction_Type,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../../styled-system/css";
import { t } from "../../../libs/i18n";
import { formatNumber } from "../../../libs/utils";

export function CellFundSources({
  transactionGroup,
}: {
  transactionGroup: TransactionGroup;
}) {
  const displayTransactions = transactionGroup.transactionDetails.filter(
    (d) =>
      d.transaction?.type === Transaction_Type.PAYMENT ||
      d.transaction?.type === Transaction_Type.PAYMENT_PSINTERNAL,
  );

  return (
    <div
      className={css({
        display: "flex",
        gap: "16px",
        justifyContent: "space-between",
        color: "text.secondary",
        borderBottom: "1px solid",
        borderColor: "border.secondary",
        pb: "16px",
      })}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        })}
      >
        <div
          className={css({
            fontSize: "14px",
            fontWeight: "bold",
          })}
        >
          {t("ポイント種類選択内訳")}
        </div>
        {displayTransactions.map((detail) => (
          <div
            key={detail.fundSource?.id}
            className={css({
              fontSize: "14px",
            })}
          >
            {detail.fundSource?.name}
          </div>
        ))}
      </div>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          fontSize: "14px",
          pt: "16px",
        })}
      >
        {displayTransactions.map((detail) => (
          <div key={detail.fundSource?.id}>
            <div>{formatNumber(-Number(detail.transaction?.amount))}pt</div>
          </div>
        ))}
      </div>
    </div>
  );
}
